import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alignItems"},[_c('span',[_vm._v(_vm._s(_vm.$t("MyWorkspaces.filterLabels.owner")))]),_c(VSelect,{attrs:{"items":_vm.userOptions,"menu-props":{ offsetY: true },"hide-details":""},model:{value:(_vm.selectedOwnerId),callback:function ($$v) {_vm.selectedOwnerId=$$v},expression:"selectedOwnerId"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }